import { render, staticRenderFns } from "./role03.vue?vue&type=template&id=a8405eca"
import script from "./role03.vue?vue&type=script&lang=js"
export * from "./role03.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports